// extracted by mini-css-extract-plugin
export default {"component":"M2jCqO","active":"Ku088B"};